import React from 'react';
import { Button } from 'antd';
import { HistoryOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const ImportProgressHistory = () => {
  const navigate = useNavigate();

  const handleViewHistory = () => {
    navigate('/orders/import-history');
  };

  return (
    <Button 
      type="primary" 
      icon={<HistoryOutlined />}
      onClick={handleViewHistory}
      style={{ 
        position: 'fixed',
        top: 20,
        right: 20,
        zIndex: 1000,
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
      }}
    >
      导入历史
    </Button>
  );
};

export default ImportProgressHistory;
